import React, { FC } from 'react';
import { Field } from 'redux-form';
import { useTranslations } from '@lang';
import { TextArea } from './TextArea';
import { NotesFieldWrapper, TitleText } from './NotesField.styles';

type NotesFieldProps = {
  name?: string;
  label?: string | JSX.Element;
  id?: string;
  placeholder?: string;
};

export const NotesField: FC<NotesFieldProps> = ({
  name = 'notes',
  label,
  id = 'notes',
  placeholder = '',
}) => {
  const { t } = useTranslations();
  return (
    <NotesFieldWrapper>
      <TitleText>
        <Field
          component={TextArea}
          name={name}
          label={label ?? t('additional.notes')}
          id={id}
          placeholder={placeholder}
        />
      </TitleText>
    </NotesFieldWrapper>
  );
};
